<div class="list-container" *ngIf="list && companylist; else notCompany">

  <div class="list-checkbox" *ngIf="companyAdd">
    <label class="check-container">
      <input type="checkbox" (click)="selectedCheckBoxItem(list.tenantId, '')" [checked]="checked"
        [value]="list?.userId" [disabled]="list.isTenantExpired">
      <span class="checkmark"></span>
    </label>
  </div>

  <div class="list-details" (click)="showDetailsHandler(list)">
    <div class="details-section" [routerLink]="['/company/details', list.tenantId]">
      <div class="row-1">
        <span class="name">{{list?.tenantName}}</span>
      </div>
      <div class="row-2" *ngIf="list?.buildingList">
        <span class="title" *ngFor="let building of list?.buildingList | addLimiter: list?.buildingList:'company'"
          [innerHTML]="building"></span>
      </div>
    </div>
  </div>

  <div class="list-option" #dotDropdown
    (click)="$event.stopPropagation();chechPopup(list);openOptionDrawer = !openOptionDrawer"
    *ngIf="companyAdd && !list.isTenantExpired">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div *ngIf="openOptionDrawer" class="drawer-container">
      <p *ngIf="list.isActive" (click)="markCompStatus(list, 'deactive')">De-activate company</p>
      <p *ngIf="!list.isActive" (click)="markCompStatus(list, 'active')">Activate company</p>
    </div>
  </div>

</div>


<ng-template #notCompany>
  <div class="list-container" *ngIf="list">

    <div class="list-checkbox" *ngIf="companyAdd">
      <label class="check-container" *ngIf="list.isVerified && list.isRegistered;else noCheckbox">
        <!-- <label class="check-container" *ngIf="((list?.employeeRole !== Roles.ParkAdmin && DisplayType.AdminCoadmin === displayType) || (DisplayType.AdminCoadmin !== displayType && list?.employeeRole !== Roles.ParkAdmin && list?.employeeRole !== Roles.ParkCoAdmin)); else noCheckbox"> -->
        <!-- <label class="check-container" *ngIf="((DisplayType.AdminCoadmin !== displayType && list?.employeeRole !== Roles.ParkCoAdmin) || (list?.employeeRole !== Roles.ParkAdmin)); else noCheckbox"> -->
        <input type="checkbox" (click)="selectedCheckBoxItem(list.userId, list.employeeRole)" [checked]="checked"
          [value]="list?.userId">
        <span class="checkmark"></span>
      </label>
      <ng-template #noCheckbox>
        <label class="check-container" style="visibility: hidden;">
          <input type="checkbox" [disabled]="true">
          <span class="checkmark"></span>
        </label>
      </ng-template>
    </div>

    <div class="list-image" (click)="showDetailsHandler(list)">
      <img [src]="list.imageUrl !== null ? list.imageUrl : defaultUserImage" alt="list-image" loading="lazy"
        class="profile-pic" />
      <img [src]="verified_user" alt="list-image-badge" loading="lazy" class="profile-badge"
        *ngIf="DisplayType.Inactive != displayType && list?.isVerified == true" />
      <img [src]="bloacked_user" alt="list-image-badge" loading="lazy" class="profile-badge"
        *ngIf="DisplayType.Inactive == displayType && list?.isBlocked == true; else archvied" />
      <img [src]="not_verfied_user" alt="list-image-badge" loading="lazy" class="profile-badge"
        *ngIf="DisplayType.Inactive != displayType && list?.isVerified == false" />
      <ng-template #archvied>
        <img [src]="archived_user" alt="list-image-badge" loading="lazy" class="profile-badge"
          *ngIf="DisplayType.Inactive == displayType && list?.isActive == false" />
      </ng-template>
    </div>

    <div class="list-details" (click)="showDetailsHandler(list)">
      <div class="details-section">
        <div class="row-1">
          <span [ngClass]="{'noRegisteredUser': !list.isRegistered}" class="name">{{list?.name}}</span><span
            class="role"
            *ngIf="DisplayType.Inactive !== displayType && (list.employeeUserRole == 'Admin' || list.employeeUserRole == 'Co-Admin'|| list.employeeUserRole == 'ERT')">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{list?.employeeUserRole}}</span>
          <span class="role" *ngIf="DisplayType.Inactive === displayType">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;<span
              *ngIf="list.isBlocked; else deactiveDate" class="red">Blocked on {{list?.modifiedDate |
              customDate}}</span><ng-template #deactiveDate><span class="grey" *ngIf="!list.isActive">De-activated on
                {{list?.modifiedDate | customDate}}</span></ng-template></span>
        </div>
        <div class="row-2"
          *ngIf="DisplayType.Active !== displayType && DisplayType.Inactive !== displayType; else noTitle">
          <span class="title">{{list?.email}}</span><span
            class="title">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;{{list?.phoneNumber}}</span>
        </div>
        <ng-template #noTitle>
          <div class="row-2" *ngIf="list?.buildingName">
            <span class="title" *ngFor="let building of list?.buildingName | addLimiter: list?.buildingName"
              [innerHTML]="building"></span>
          </div>
        </ng-template>
      </div>
    </div>


    <div class="list-status"
      *ngIf="DisplayType.Active === displayType && list.employeeUserRole == 'GeneralUser' && companyAdd">
      <p *ngIf="list.isApproved; else PendingInvite" class="blue" (click)="selectedStatusUpdate(list, 'revoke')">
        Revoke
        VMS Access</p>
      <ng-template #PendingInvite>
        <ng-container *ngIf="list.isApproved == false">
          <p class="orange" (click)="selectedStatusUpdate(list, 'approve')">Approve VMS Access</p>
        </ng-container>
      </ng-template>
    </div>



    <!-- <div class="list-option"
    (click)="$event.stopPropagation();openOptionDrawer = !openOptionDrawer" *ngIf="DisplayType.ERT !== displayType && DisplayType.AdminCoadmin !== displayType">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div *ngIf="openOptionDrawer" class="drawer-container">
      <p>Block</p>
      <p>Verify</p>
      <p>Deactivate</p>
    </div>
  </div> -->
    <div class="list-option" #dotDropdown
      [ngClass]="{'auto-left': DisplayType.Active === displayType && list.employeeUserRole != 'GeneralUser', 'margin-unset': DisplayType.Active === displayType && list.employeeUserRole == 'GeneralUser'}"
      (click)="$event.stopPropagation();chechPopup(list);openOptionDrawer = !openOptionDrawer"
      *ngIf="DisplayType.Inactive !== displayType && list.isVerified && list.isRegistered && companyAdd">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div *ngIf="openOptionDrawer" class="drawer-container">
        <p *ngIf="list.employeeRole !== Roles.ParkAdmin" (click)="markUserStatus(list, Roles.ParkAdmin)">Mark as Admin
        </p>
        <p *ngIf="list.employeeRole === Roles.ParkAdmin" (click)="removeUserStatus(list, Roles.ParkAdmin)">Remove as
          Admin</p>
      </div>
    </div>
  </div>
</ng-template>